import type { ReactNode } from 'react';

interface EmptyStateTextProps {
  icon?: ReactNode;
  title: string;
  subtitle: ReactNode;
}

export const EmptyStateText = ({ icon, title, subtitle }: EmptyStateTextProps) => (
  <div className="flex flex-col items-center justify-center text-center">
    {icon}
    <div className="text-[13px] text-zinc-400">{title}</div>
    <div className="mt-0.5 text-[12px] text-zinc-500">{subtitle}</div>
  </div>
);
